import React from 'react';
import { BarChart3, Trophy, DollarSign, TrendingUp } from 'lucide-react';

const Stats = ({ bets }) => {
  const totalBets = bets.length;
  const wins = bets.filter(b => b.status === 'won').length;
  const losses = bets.filter(b => b.status === 'lost').length;
  const pending = bets.filter(b => !b.status || b.status === 'pending').length;
  
  // Calculate based on units
  const totalUnitsStaked = bets.reduce((sum, bet) => sum + parseFloat(bet.units || 1), 0);
  const totalUnitsReturned = bets
    .filter(b => b.status === 'won')
    .reduce((sum, bet) => sum + (parseFloat(bet.units || 1) * parseFloat(bet.odds)), 0);
  const unitsProfit = totalUnitsReturned - totalUnitsStaked;
  const roi = totalUnitsStaked > 0 ? ((unitsProfit / totalUnitsStaked) * 100).toFixed(2) : 0;
  const winRate = (wins + losses) > 0 ? ((wins / (wins + losses)) * 100).toFixed(1) : 0;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      <div className="bg-white rounded-lg p-4 shadow">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm text-gray-500">Total Bets</h3>
          <BarChart3 size={16} className="text-green-400" />
        </div>
        <p className="text-2xl font-bold text-gray-800">{totalBets}</p>
        <p className="text-xs text-gray-600">{wins}W - {losses}L - {pending}P</p>
      </div>
      <div className="bg-white rounded-lg p-4 shadow">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm text-gray-500">Win Rate</h3>
          <Trophy size={16} className="text-green-400" />
        </div>
        <p className="text-2xl font-bold text-gray-800">{winRate}%</p>
      </div>
      <div className="bg-white rounded-lg p-4 shadow">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm text-gray-500">Units P/L</h3>
          <DollarSign size={16} className="text-green-400" />
        </div>
        <p className={`text-2xl font-bold ${unitsProfit >= 0 ? 'text-green-600' : 'text-red-600'}`}>
          {unitsProfit >= 0 ? '+' : ''}{unitsProfit.toFixed(2)}u
        </p>
      </div>
      <div className="bg-white rounded-lg p-4 shadow">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm text-gray-500">ROI</h3>
          <TrendingUp size={16} className="text-green-400" />
        </div>
        <p className={`text-2xl font-bold ${roi >= 0 ? 'text-green-600' : 'text-red-600'}`}>
          {roi}%
        </p>
      </div>
    </div>
  );
};

export default Stats;
